import { FlexBox, FormError, Label, SearchableSelect } from '@helloself/hello-self-ui';
import { FormikProps } from 'formik';
import React from 'react';

import { ProfileFormValues } from '../EditModal';

type ExpertiseListEntryProps = FormikProps<ProfileFormValues> & {
    fieldName: 'otherTopics';
    label: string;
    values: Pick<ProfileFormValues, 'otherTopics'>;
    options: string[];
};

export function ExpertiseListEntry({
    fieldName,
    label,
    values,
    options,
    errors,
    touched,
    handleBlur,
    setFieldValue,
}: ExpertiseListEntryProps) {
    const dropdownOptions = options.map((option) => ({ label: option, value: option }));
    const isInvalid = !!errors[fieldName] && !!touched[fieldName];

    return (
        <FlexBox flexDirection="column" gap="4px">
            <Label textAlign={'justify'} htmlFor={fieldName} margin="0">
                {label}
            </Label>
            <SearchableSelect
                id={fieldName}
                height="auto"
                fontSize="14px"
                minHeight="48px"
                optionHeight="36px"
                isMulti={true}
                isClearable={false}
                isInvalid={isInvalid}
                options={dropdownOptions}
                placeholder="Please select"
                value={values[fieldName].map((value: string) => ({
                    value,
                    label: dropdownOptions.find((option) => option.value === value)?.label,
                }))}
                onBlur={handleBlur}
                onChange={(options) => {
                    setFieldValue(
                        fieldName,
                        options.map((item) => item?.value)
                    );
                }}
                aria-label={`${fieldName} select`}
            />
            {isInvalid && (
                <FormError textSize="xsmall" margin="0">
                    {errors[fieldName]}
                </FormError>
            )}
        </FlexBox>
    );
}
